import {
  formatBrazilianCurrency,
  formatPrice,
} from "shared/utils/formatBrazilianCurrency";
import { useGlobalContext } from "shared/utils/hooks/useGlobalContext";

import useCheckoutStepsOffersContext from "@CheckoutStepsOffers/provider";

import DiscountInformation from "../../DiscountInformation";
import {
  ContainerProductPriceOverviewPix,
  ContentSpecialOffers,
  ContentTotalPrice,
  Discount,
  Paragraph,
  ParagraphTotal,
  ParagraphTotalValue,
  Row,
} from "./styles";

const FinalPricesPixBoleto = () => {
  const { offer, coupon, installments, orderBumpsSelected } =
    useCheckoutStepsOffersContext();

  const { state } = useGlobalContext();

  const acquirer = state?.tenancy?.acquirer;

  const IS_MIN_VALUE =
    acquirer?.complement_min_value &&
    installments[0]?.value < acquirer?.min_value;
  const HAS_VALUE_TO_PAY = installments[0]?.value > 0;

  const totalOrderBumpsPrice = orderBumpsSelected?.reduce(
    (total, orderBump) => {
      return total + (parseFloat(orderBump?.price) || 0);
    },
    0,
  );

  const totalCheckout = installments[0].value + totalOrderBumpsPrice;

  return (
    <ContainerProductPriceOverviewPix>
      <Row>
        <Paragraph>{offer?.group?.title}</Paragraph>
        {IS_MIN_VALUE && HAS_VALUE_TO_PAY && totalCheckout < 1 ? (
          <Paragraph>{formatBrazilianCurrency(acquirer?.min_value)}</Paragraph>
        ) : (
          <Paragraph>
            {formatBrazilianCurrency(Number(offer?.offer?.price))}
          </Paragraph>
        )}
      </Row>
      {!!coupon && (
        <>
          <Row>
            <Paragraph>Desconto</Paragraph>
            <Discount>
              - {formatBrazilianCurrency(coupon?.item?.coupon_discount_value)}
            </Discount>
          </Row>
        </>
      )}

      {IS_MIN_VALUE && HAS_VALUE_TO_PAY && totalCheckout < 1 && (
        <Row>
          <Paragraph>{offer?.group?.title}</Paragraph>
          <Paragraph>{formatBrazilianCurrency(acquirer?.min_value)}</Paragraph>
        </Row>
      )}

      <DiscountInformation />
      <ContentSpecialOffers>
        {orderBumpsSelected?.map((orderBump) => (
          <Row key={orderBump?.id}>
            <Paragraph>{orderBump?.group?.title}</Paragraph>
            <Paragraph>
              {formatBrazilianCurrency(formatPrice(orderBump?.price))}
            </Paragraph>
          </Row>
        ))}
      </ContentSpecialOffers>

      <ContentTotalPrice>
        <Row>
          <ParagraphTotal>Total</ParagraphTotal>
          <ParagraphTotalValue>
            {" "}
            {formatBrazilianCurrency(totalCheckout)}
          </ParagraphTotalValue>
        </Row>
      </ContentTotalPrice>
    </ContainerProductPriceOverviewPix>
  );
};

export default FinalPricesPixBoleto;
